//Principais
import { Router } from "@angular/router";
import { Location } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild, inject } from "@angular/core";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, RouterLink } from '@angular/router';
import { ToastrService } from "ngx-toastr";
import { Subscription, lastValueFrom } from "rxjs";
import SwiperCore, { A11y, Autoplay, Controller, Navigation, Pagination, Scrollbar, SwiperOptions, Virtual, Zoom } from 'swiper';
//Models
import { ArquivoAzure } from 'src/app/shared/models/arquivo/ArquivoAzure';
import { ChamadoDetalhes } from 'src/app/shared/models/chamados/chamadoDetalhes';
import { Envolvido } from 'src/app/shared/models/chamados/envolvido';
import { HistoricoChamado } from "src/app/shared/models/chamados/historico";
import { ListarChamados } from "src/app/shared/models/chamados/listar-chamados";
import { AtribuicaoLoginSed, UserLoginSed } from "src/app/shared/models/sed/UserLogin";
import { ChamadoDeletar } from "src/app/shared/models/chamados/chamadoDeletar";
//Services
import { saveAs } from "file-saver";
import { NgxSpinnerService } from 'ngx-spinner';
import { ConvivaApi } from "src/app/conviva-api";
import { AuthService } from "src/app/shared/auth/services/auth.service";
import { ArquivoService } from 'src/app/shared/services/arquivo.service';
import { ChamadoService } from "src/app/shared/services/chamado.service";
import { ConvivaErrorHandlingService } from 'src/app/shared/services/convivaErrorHandlingService';
import { DetalheService } from 'src/app/shared/services/detalhe.service';
import { HistoricoChamadoService } from "src/app/shared/services/historicoChamado.service";
import { ModalService } from "src/app/shared/services/modal.service";
import { angularCommonImports } from "src/app/shared/ui/angular-common";
import { convivaCommonImports } from "src/app/shared/ui/conviva-common";
import { libsCommonImports } from "src/app/shared/ui/libs-common";
import { SwiperModule } from 'swiper/angular';
import { ConcluirService } from "src/app/shared/services/concluir.service";
import { EncaminhamentoService } from "src/app/shared/services/encaminhamento.service";
import { VisualizarArquivoComponent } from "components/visualizar-arquivo/visualizar-arquivo.component";
import { EnvolvidoService } from "src/app/shared/services/envolvido.service";

// install Swiper components
SwiperCore.use([
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Virtual,
  Zoom,
  Autoplay,
  Controller
]);

@Component({
  selector: 'app-detalhe',
  templateUrl: './detalhe.component.html',
  styleUrls: ['./detalhe.component.scss'],
  standalone: true,
  imports: [angularCommonImports, libsCommonImports, convivaCommonImports, SwiperModule, RouterLink, VisualizarArquivoComponent]
})

export class DetalheComponent implements OnInit {

  private spinnerService = inject(NgxSpinnerService);
  private detalheService = inject(DetalheService);
  private chamadoService = inject(ChamadoService);
  private historicoChamadoService = inject(HistoricoChamadoService);
  private ConvivaErrors = inject(ConvivaErrorHandlingService);
  private authService = inject(AuthService);
  private arquivoService = inject(ArquivoService);
  private toastr = inject(ToastrService);
  private route = inject(ActivatedRoute);
  private modalService = inject(ModalService);
  private location = inject(Location);
  private router = inject(Router);
  private concluirService = inject(ConcluirService);
  private encaminhamentoService = inject(EncaminhamentoService);
  private envolvidoService = inject(EnvolvidoService);

  private api = ConvivaApi;
  public userLogado: UserLoginSed | null;
  public atribuicoesLogin: AtribuicaoLoginSed;
  private modalSubscription: Subscription;
  public qtdeCaracteresDescricao: number = 0;


  constructor(
  ) {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.parametroId = params.get('id');
    });

    this.userLogado = this.authService.getUser();
    this.modalSubscription = this.modalService.modalClicked$.subscribe(() => {
      this.showModalArquivo = false;
    });

    if (this.userLogado != null && !this.userLogado.flPsicologo) {
      this.atribuicoesLogin = this.userLogado?.DadosUsuario[0];
    }
  }

  @ViewChild('archivoInput', { static: false }) archivoInput: ElementRef;
  public chamado: ChamadoDetalhes;
  public envolvidos: Envolvido[] = [];
  public file: ArquivoAzure | null = null;
  public formVisualizar!: FormGroup;
  public formCadastrarHistorico!: FormGroup;
  public formCadastrarHistoricoDetalhe!: FormGroup;
  public formAddInfoHistorico!: FormGroup;
  public parametroId: any;
  public showModalDetalheEnvolvido = false;
  public chamadoHistorico: ListarChamados;
  public itemChamado: ListarChamados;
  public lstHistoricos: HistoricoChamado[] = [];
  public lstHistoricosDetalheEnvolvido: HistoricoChamado[] = [];
  public historico: HistoricoChamado | undefined;
  public statusCriada: any;
  public statusEncaminhada: any;
  public statusFechada: any;
  public nomeSelected: any;
  public dsHistoricoChamado: string;
  public dsHistoricoChamadoDetalhe: string;
  public files: ArquivoAzure[] = [];
  public showModalArquivo: boolean;
  public showModalAddInfoHistorico: boolean;
  public get arquivoPDF() {
    return this.chamado.caminhoArquivo && this.chamado.caminhoArquivo[0].endsWith('.pdf')
  }

  // Modal Encerrar Chamado Envolvido
  public showModalConcluirChamado = false;
  public ShowModalEncerrarChamado = false;
  public descricaoConcluir = "";
  public chamadoAConcluir = 0;

    // Modal Excluir
    public showModalExcluirChamado = false;
    public descricaoExclusao = "";
    public chamadoARemover = 0;

  // Modal Encaminhar
  public showModalEncaminhar = false;
  public showModalConfirmarEncaminhamento = false;
  public showModalSucessoEncaminhamento = false;
  public tipoEncaminhamento: string = "";
  public codigoChamadoEncaminhar = 0;
  public codigoEnvolvidoEncaminhar = 0;
  public filesEncaminhamento: ArquivoAzure[] = [];
  public mensagemConfirmacaoEncaminhamento = "";
  public mensagemSucessoEncaminhamento = "";
  public tipoEncaminhamentoPolicia = 0;
  public showModalSelecionarEnvolvidoEncaminhamento = false;
  public turmasEnvolvidos: Envolvido[] = [];
  public cssBtnPsicologo = "";
  public cssBtnPolicia = "";
  public cssBtnHospital = "";

  // Modal Histórico de Status
  public showModalHistoricoStatus = false;
  public historicosStatus: HistoricoChamado[] = [];

  // Modal Agendamento
  public showModalAgendamento = false;
  public envolvidoAgendamento: Envolvido | null = null;

  goBack(): void {
    this.location.back();
  }

  // FORM CADASTRAR
  public get form() {
    return this.formVisualizar.controls;
  }

  public podeMostrarEncaminhar(): boolean {
    const funcionalidades = this.userLogado?.funcionalidades;
    if (!funcionalidades || funcionalidades.length === 0) {
      return false;
    }
    return funcionalidades.includes(6) || funcionalidades.includes(7) || funcionalidades.includes(8);
  }

  /**
   * Verifica se pode exibir o botão de encaminhar para o envolvido atual.
   * Regras:
   * - Usuário deve ter permissão (funcionalidade 6, 7 ou 8)
   * - Envolvido não pode ser Equipe Escolar (tipoPessoa !== 2)
   */
  public podeEncaminhar(): boolean {
    if (!this.podeMostrarEncaminhar()) {
      return false;
    }

    // Não exibir para Equipe Escolar
    if (this.envolvidos && this.envolvidos.length > 0) {
      const primeiroEnvolvido = this.envolvidos[0];
      if (primeiroEnvolvido.tipoPessoa === 2) {
        return false;
      }
    }

    return true;
  }

  public async ngOnInit() {
    this.formVisualizar = new FormGroup({});
    this.formCadastrarHistorico = new FormGroup({
      dsHistoricoChamado: new FormControl(null),
    });
    this.formCadastrarHistoricoDetalhe = new FormGroup({
      dsHistoricoChamado: new FormControl(null),
    });
    this.formAddInfoHistorico = new FormGroup({
      newInfoHistoric: new FormControl(null, [Validators.maxLength(500), Validators.minLength(10)])
    });
    await this.PopularDados();
  }

  public async PopularDados() {
    this.spinnerService.show();
    const result = await lastValueFrom(await this.detalheService.getChamadoDetalhePorId(this.parametroId))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }
    this.chamado = result.data;
    this.envolvidos = this.chamado.envolvidos
    let currentId = 1;
    this.envolvidos.forEach(pessoa => {
      pessoa.idTemporario = currentId++;
      pessoa.imagemTemporaria = pessoa.iniciais;//this.GerarIniciais(pessoa.nome!)
      pessoa.iniciais = pessoa.tipoPessoa == 3 ? "X" : pessoa.iniciais;
    });

    await this.carregarHistoricoStatus();
    await this.carregarHistoricoAnotacoes();
    const arquivodata: ArquivoAzure = {
      nome: this.chamado.nomeArquivo!,
      ehBase64: true,
      caminhoAzure: this.chamado.caminhoArquivo![0],
      conteudo: this.chamado.conteudoBase64!
    };
    this.file = arquivodata;

    setTimeout(() => {
      this.spinnerService.hide();
    }, 3000);
  }

  public configs: SwiperOptions = {
    slidesPerView: 2,
    spaceBetween: 20,
    breakpoints: {
      600: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      800: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1000: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
    },
  };

  public GerarIniciais(nomeAluno: string) {
    return nomeAluno
      ?.split(' ')
      .filter((parte) => parte.length > 3) // Filtra partes do nome com mais de 3 letras
      .map((parte) => parte.charAt(0)) // Mapeia para as iniciais
      .slice(0, 2) // Pega apenas as duas primeiras iniciais
      .join('');
  }

  /** Formata CPF como 000.000.000-00. Aceita number (API) ou string. */
  public formatarCpf(cpf: number | string | null | undefined): string {
    if (cpf == null || cpf === '') return '';
    const str = String(cpf).replace(/\D/g, '');
    if (str.length !== 11) return str;
    return str.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  /** Retorna a linha do cabeçalho: Estudante = RA - Nome; Equipe Escolar = CPF - Nome. */
  public getLinhaIdentificadorCabecalho(envolvido: Envolvido | null | undefined): string {
    if (!envolvido) return 'Nome completo';
    const nome = envolvido.nome || 'Nome completo';
    const tipo = envolvido.tipoPessoa;
    // EquipeEscolar = 2: CPF - Nome
    if (tipo === 2) {
      const cpf = envolvido.cpf != null ? this.formatarCpf(envolvido.cpf) : '';
      return cpf ? `${cpf} - ${nome}` : nome;
    }
    // Estudante (1) ou Outros/Aluno (3): RA - Nome
    const ra = envolvido.ra ?? '';
    return ra ? `${ra} - ${nome}` : nome;
  }

  public FecharModalArquivo() {
    this.showModalArquivo = false;
  }

  public AbrirModalArquivo() {
    this.showModalArquivo = true;
  }

  public async HistoricoChamado(cdChamado: number, cdEnvolvido?: number, nome?: string) {
    this.spinnerService.show();
    const chamadoEnvolvido = new ListarChamados();
    chamadoEnvolvido.codigoChamado = cdChamado;
    chamadoEnvolvido.codigoEnvolvido = cdEnvolvido == null ? 0 : cdEnvolvido;
    this.nomeSelected = nome;
    const menu = document.getElementsByClassName("time-line")
    if (menu.length > 0) {
      const teste = menu.item(0) as HTMLElement;
      teste.className = "sidebar-chamado";
    }
    this.itemChamado = chamadoEnvolvido;
    const result = await lastValueFrom(await this.chamadoService.getHistoricoEnvolvido(chamadoEnvolvido))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }
    this.lstHistoricosDetalheEnvolvido = result.data;
    this.chamadoHistorico = chamadoEnvolvido;
    this.setStatusHistorico();
    this.showModalDetalheEnvolvido = true;
    this.spinnerService.hide();
  }

  public setStatusHistorico() {
    const criados = this.lstHistoricosDetalheEnvolvido.filter(x => x.statusChamado == 0);
    if (criados.length > 0)
      this.statusCriada = criados[0].data;
    else
      this.statusCriada = null;
    const encaminhados = this.lstHistoricosDetalheEnvolvido.filter(x => x.statusChamado == 1);
    if (encaminhados.length > 0)
      this.statusEncaminhada = encaminhados[0].data;
    else
      this.statusEncaminhada = null;
    const fechados = this.lstHistoricosDetalheEnvolvido.filter(x => x.statusChamado == 5);
    if (fechados.length > 0)
      this.statusFechada = fechados[0].data;
    else
      this.statusFechada = null;
  }

  public async OnFileChange(event: any) {
    const maxFileSize = 31 * 1024 * 1024; // 30 MB

    if (event.target.files.length > 0) {
      this.spinnerService.show();
      const formData = new FormData();
      const files = event.target.files;
      for (const file of files) {
        const fileName = file.name.split('.')[0];

        if (fileName.length > 30) {
          const fileInput = document.getElementById('arquivos') as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }
          this.toastr.warning('O nome do arquivo não pode ter mais de 30 caracteres.');
          this.spinnerService.hide();
          return;
        }

        if (file.size > maxFileSize) {
          this.toastr.warning('O tamanho máximo do arquivo é 30 MB.');
          const fileInput = document.getElementById('arquivos') as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }
          this.spinnerService.hide();
          return;
        }

        if (file.type == "image/jpg" ||
          file.type == "image/jpeg" ||
          file.type == "image/png" ||
          file.type == "application/pdf" ||
          file.type == "application/ppt" ||
          file.type == "application/pptx" ||
          file.type == "application/potx" ||
          file.type == "application/ppsx" ||
          file.type == "application/odp" ||
          file.type == "audio/mpeg" ||
          file.type == "video/mp4"
        ) {
          formData.append(file.name, file);
        }
        else {
          this.toastr.warning('Só é possivel subir arquivos .jpg, .jpeg , .png, .pdf, .mp3 , .mp4, .ppt, .pptx, .potx e ppsx');
          const fileInput = document.getElementById('arquivos') as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }
          this.spinnerService.hide();
          return;
        }
      }


      const result = await lastValueFrom(this.arquivoService.setArquivoBase64(formData))
        .catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });

      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }

      this.files.push(...result.data);
      event.target.value = '';

      this.spinnerService.hide();
    }
  }

  public limpiarInputArchivo() {
    this.archivoInput.nativeElement.value = null;
  }

  private obterDescricaoHistoricoAtual(origem: 'sidebar' | 'detalhe' = 'sidebar'): string {
    const formulario = origem === 'sidebar'
      ? this.formCadastrarHistorico
      : this.formCadastrarHistoricoDetalhe;
    const valorModelo = origem === 'sidebar'
      ? this.dsHistoricoChamado
      : this.dsHistoricoChamadoDetalhe;

    const valorFormulario = formulario.get('dsHistoricoChamado')?.value;
    const valor = (valorFormulario ?? valorModelo ?? '').toString().trim();
    return valor;
  }

  public async onSalvarHistorico(origem: 'sidebar' | 'detalhe' = 'sidebar') {
    await this.salvarAnotacaoSidebar(origem);
  }

  // Salvar anotação do sidebar
  public async salvarAnotacaoSidebar(origem: 'sidebar' | 'detalhe' = 'sidebar') {
    this.spinnerService.show();
    const descricaoHistorico = this.obterDescricaoHistoricoAtual(origem);

    const objetoHistorico: HistoricoChamado = {
      codigoChamado: this.parametroId,
      codigoEnvolvido: 0,
      descricaoHistorico,
      statusChamado: 0,
      nomeArquivo: this.files.length == 0 ? "" : this.files[0].nome,
      caminhoArquivo: this.files.length == 0 ? "" : this.files[0].caminhoAzure,
      codigoPerfil: this.userLogado?.flPsicologo ? this.userLogado.codigoPerfil : this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.userLogado?.flPsicologo ? this.userLogado.nomePerfil : this.atribuicoesLogin.NomePerfil,
      conteudo: this.files.length == 0 ? "" : this.files[0].conteudo
    };

    if (objetoHistorico.nomeArquivo == "" && !objetoHistorico.descricaoHistorico) {
      this.spinnerService.hide();
      this.toastr.error('É obrigatório a descrição ou foto');
      return;
    }
    
    const result = await lastValueFrom(await this.historicoChamadoService.setCadastrarHistoricoChamado(objetoHistorico))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
      
    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }
    
    // Recarregar anotações
    await this.carregarHistoricoAnotacoes();
    const formulario = origem === 'sidebar'
      ? this.formCadastrarHistorico
      : this.formCadastrarHistoricoDetalhe;
    formulario.get('dsHistoricoChamado')?.patchValue(null);
    if (origem === 'sidebar') {
      this.dsHistoricoChamado = '';
    } else {
      this.dsHistoricoChamadoDetalhe = '';
    }
    this.limpiarInputArchivo();
    this.files = [];
    this.spinnerService.hide();
    this.toastr.success('Anotação salva com sucesso.');
  }

  downloadDocument(urlArquivo: string | undefined) {
    if (!urlArquivo) {
      console.error('URL do arquivo não fornecida');
      this.toastr.error('Não foi possível baixar o arquivo.');
      return;
    }
    
    try {
      const nomeArquivo = this.extraiNomeArquivoDaUrlComGuid(urlArquivo);
      this.spinnerService.show();
      this.arquivoService.getArquivoPorNome(nomeArquivo).subscribe({
        next: (data) => {
          saveAs(data, this.extraiNomeArquivoDaURLSemGuid(urlArquivo));
          this.spinnerService.hide();
        },
        error: (error) => {
          console.error('Erro ao baixar arquivo:', error);
          this.toastr.error('Erro ao baixar o arquivo.');
          this.spinnerService.hide();
        }
      });
    } catch (error) {
      console.error('Erro ao processar download:', error);
      this.toastr.error('Erro ao processar o download.');
      this.spinnerService.hide();
    }
  }

  extraiNomeArquivoDaUrlComGuid(caminho: string) {
    const segmento = caminho.split('/').pop() ?? '';
    const semQuery = segmento.includes('?') ? segmento.split('?')[0] : segmento;
    try {
      return decodeURIComponent(semQuery);
    } catch {
      return semQuery;
    }
  }
  extraiNomeArquivoDaURLSemGuid(url: string | undefined) {
    if (!url)
      return '';
    const nomeArquivo = this.extraiNomeArquivoDaUrlComGuid(url);
    const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-/;
    const nomeAquivoLimpo = nomeArquivo.replace(regex, '');
    try {
      return decodeURIComponent(nomeAquivoLimpo);
    } catch (error) {
      // Se fallar a decodificação, retorna o nome sem decodificar
      return nomeAquivoLimpo;
    }
  }

  private montarArquivoParaVisualizacao(caminho: string): ArquivoAzure {
    return {
      nome: this.extraiNomeArquivoDaUrlComGuid(caminho),
      nomeOriginal: this.extraiNomeArquivoDaURLSemGuid(caminho),
      conteudo: '',
      ehBase64: false,
      caminhoAzure: caminho,
    };
  }

  openModalAddInfo(cdHistorico: number | undefined) {
    this.showModalAddInfoHistorico = true;
    if (cdHistorico != 0) {
      this.historico = this.lstHistoricosDetalheEnvolvido.find(s => s.codigoHistorico == cdHistorico)
        ?? this.lstHistoricos.find(s => s.codigoHistorico == cdHistorico);
    }

  }

  closeModalAddInfo() {
    this.formAddInfoHistorico.get('newInfoHistoric')?.setValue(null);
    this.qtdeCaracteresDescricao = 0;
    this.showModalAddInfoHistorico = false;
  }


  async saveNewInfoOnHistoric() {
    this.spinnerService.show();
    const novaInfo = this.formAddInfoHistorico.get('newInfoHistoric')!.value;
    if (this.formAddInfoHistorico.invalid) {
      this.toastr.error('O campo está vazio ou não cumpre o mínimo de caracteres.');
      this.spinnerService.hide();
      return;
    }
    const body = {
      cdHistorico: this.historico?.codigoHistorico,
      novaInformacao: novaInfo
    };


    const result = await lastValueFrom(await this.historicoChamadoService.SetInformacaoAdicional(body))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }

    this.toastr.success(result.data.mensagem);

    this.closeModalAddInfo();
    await this.HistoricoChamado(this.historico!.codigoChamado, this.historico?.codigoEnvolvido);
    await this.carregarHistoricoAnotacoes();
    this.spinnerService.hide();
  }

  public OnChangeCountLetters() {
    const descricao = this.formAddInfoHistorico.get('newInfoHistoric')!.value;
    if (descricao != null)
      this.qtdeCaracteresDescricao = descricao.length;
  }

  public OnEditarChamado(codigoChamdo: number) {
    this.router.navigate([`/editar-chamados/${codigoChamdo}`]);
  }

  public visualizarArquivo(caminho: string) {
    if (!caminho) {
      console.error('Caminho do arquivo não fornecido');
      return;
    }

    this.file = this.montarArquivoParaVisualizacao(caminho);
    this.AbrirModalArquivo();
  }

  public async abrirModalEncaminhar(codigoChamado: number, codigoEnvolvido: number, tipoPreSelecionado?: string) {
    
    this.codigoChamadoEncaminhar = codigoChamado;
    this.codigoEnvolvidoEncaminhar = codigoEnvolvido;
    this.tipoEncaminhamento = tipoPreSelecionado || "";
    this.filesEncaminhamento = [];
    this.showModalEncaminhar = true;
    this.showModalSelecionarEnvolvidoEncaminhamento = false;

    this.cssBtnPsicologo = "";
    this.cssBtnPolicia = "";
    this.cssBtnHospital = "";

    if (this.tipoEncaminhamento != "" ) {
      this.PrepararEncaminhamento(this.tipoEncaminhamento)
    }

    if (codigoEnvolvido > 0) {
      this.codigoEnvolvidoEncaminhar = codigoEnvolvido;
      this.SelecionarVitima();
      return;
    }

    const result = await lastValueFrom(await this.envolvidoService.GetEnvolvidosPorChamado(codigoChamado))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });

    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }
    this.turmasEnvolvidos = result.data;
    this.turmasEnvolvidos = this.turmasEnvolvidos.filter(item => item.dsEstatusEnvolvido === 'Não Analisado');

    if (this.turmasEnvolvidos.length == 0) {
      this.fecharModalEncaminhar();
      this.toastr.error("Chamado já encaminhado", "Atenção");
      this.spinnerService.hide();
      return;
    }

    if (this.turmasEnvolvidos.length == 1) {
      this.codigoEnvolvidoEncaminhar = this.turmasEnvolvidos[0]?.codigoEnvolvido ?? 0;
      this.SelecionarVitima();
      return;
    }

    this.showModalEncaminhar = false;
    this.showModalSelecionarEnvolvidoEncaminhamento = true;
  }

  public fecharModalEncaminhar() {
    this.showModalEncaminhar = false;
    this.showModalSelecionarEnvolvidoEncaminhamento = false;
    this.tipoEncaminhamento = "";
    this.filesEncaminhamento = [];
  }

  public selecionarTipoEncaminhamento(tipo: string) {
    this.tipoEncaminhamento = tipo;
    // Apenas seleciona o tipo, não avança automaticamente
  }

  public async onFileChangeEncaminhamento(event: any) {
    const maxFileSize = 31 * 1024 * 1024; // 30 MB

    if (event.target.files.length > 0) {
      this.spinnerService.show();
      const formData = new FormData();
      const files = event.target.files;
      
      for (const file of files) {
        const fileName = file.name.split('.')[0];

        if (fileName.length > 30) {
          const fileInput = document.getElementById('arquivosEncaminhamento') as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }
          this.toastr.warning('O nome do arquivo não pode ter mais de 30 caracteres.');
          this.spinnerService.hide();
          return;
        }

        if (file.size > maxFileSize) {
          this.toastr.warning('O tamanho máximo do arquivo é 30 MB.');
          const fileInput = document.getElementById('arquivosEncaminhamento') as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }
          this.spinnerService.hide();
          return;
        }

        if (file.type == "image/jpg" ||
          file.type == "image/jpeg" ||
          file.type == "image/png" ||
          file.type == "application/pdf" ||
          file.type == "application/ppt" ||
          file.type == "application/pptx" ||
          file.type == "application/potx" ||
          file.type == "application/ppsx" ||
          file.type == "application/odp" ||
          file.type == "audio/mpeg" ||
          file.type == "video/mp4"
        ) {
          formData.append(file.name, file);
        } else {
          this.toastr.warning('Só é possivel subir arquivos .jpg, .jpeg , .png, .pdf, .mp3 , .mp4, .ppt, .pptx, .potx e ppsx');
          const fileInput = document.getElementById('arquivosEncaminhamento') as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }
          this.spinnerService.hide();
          return;
        }
      }

      const result = await lastValueFrom(this.arquivoService.setArquivoBase64(formData))
        .catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });

      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }

      this.filesEncaminhamento.push(...result.data);
      event.target.value = '';
      this.spinnerService.hide();
    }
  }

  public removerArquivoEncaminhamento(index: number) {
    this.filesEncaminhamento.splice(index, 1);
  }

  public solicitarConfirmacaoEncaminhamento() {
    if (!this.tipoEncaminhamento) {
      this.toastr.warning('Selecione um tipo de encaminhamento');
      return;
    }

    // Define a mensagem de confirmação baseada no tipo
    const mensagens: { [key: string]: string } = {
      'psicologo': 'Tem certeza que deseja encaminhar este aluno ao Psicólogo?',
      'rede-protetiva': 'Tem certeza que deseja encaminhar este aluno à Rede Protetiva?',
      'rede-hospitalar': 'Tem certeza que deseja encaminhar este aluno à Rede Hospitalar?'
    };

    this.mensagemConfirmacaoEncaminhamento = mensagens[this.tipoEncaminhamento] || 'Tem certeza que deseja realizar este encaminhamento?';
    
    // Fecha modal de seleção e abre modal de confirmação
    this.showModalEncaminhar = false;
    this.showModalConfirmarEncaminhamento = true;
  }

  public fecharModalConfirmacaoEncaminhamento() {
    this.showModalConfirmarEncaminhamento = false;
    // Volta para o modal de seleção
    this.showModalEncaminhar = true;
  }

  public fecharModalSucessoEncaminhamento() {
    this.showModalSucessoEncaminhamento = false;
    // Redireciona para a tela de chamados
    setTimeout(() => {
      this.router.navigate(['/chamados']);
    }, 500);
  }

  public async confirmarEncaminhamento() {
    this.showModalConfirmarEncaminhamento = false;

    if (!this.tipoEncaminhamento) {
      this.toastr.warning('Selecione um tipo de encaminhamento');
      return;
    }

    this.spinnerService.show();

    let objetoHistorico: HistoricoChamado;
    let response: any;

    switch (this.tipoEncaminhamento) {
      case 'psicologo':
        objetoHistorico = {
          codigoChamado: this.codigoChamadoEncaminhar,
          codigoEnvolvido: this.codigoEnvolvidoEncaminhar,
          descricaoHistorico: 'Aluno encaminhado ao Psicólogo.',
          statusChamado: 2,
          codigoPerfil: this.userLogado?.flPsicologo ? this.userLogado.codigoPerfil : this.atribuicoesLogin.CodigoPerfil,
          nomePerfil: this.userLogado?.flPsicologo ? this.userLogado.nomePerfil : this.atribuicoesLogin.NomePerfil,
          nomeArquivo: "",
          caminhoArquivo: "",
          conteudo: ""
        };
        response = await lastValueFrom(this.encaminhamentoService.setCadastrarEncaminhamento(objetoHistorico))
          .catch((err) => {
            return this.ConvivaErrors.handleResultError(err);
          });
        break;

      case 'rede-protetiva':
        objetoHistorico = {
          codigoChamado: this.codigoChamadoEncaminhar,
          codigoEnvolvido: this.codigoEnvolvidoEncaminhar,
          descricaoHistorico: 'Aluno encaminhado a Rede protetiva.',
          statusChamado: 2,
          codigoPerfil: this.userLogado?.flPsicologo ? this.userLogado.codigoPerfil : this.atribuicoesLogin.CodigoPerfil,
          nomePerfil: this.userLogado?.flPsicologo ? this.userLogado.nomePerfil : this.atribuicoesLogin.NomePerfil,
          nomeArquivo: this.filesEncaminhamento.length > 0 ? this.filesEncaminhamento[0].nome : "",
          caminhoArquivo: this.filesEncaminhamento.length > 0 ? this.filesEncaminhamento[0].caminhoAzure : "",
          conteudo: this.filesEncaminhamento.length > 0 ? this.filesEncaminhamento[0].conteudo : "",
          anexos: this.filesEncaminhamento        
        };
        response = await lastValueFrom(this.encaminhamentoService.setCadastrarEncaminhamentoPolicia(objetoHistorico))
          .catch((err) => {
            return this.ConvivaErrors.handleResultError(err);
          });
        break;

      case 'rede-hospitalar':
        objetoHistorico = {
          codigoChamado: this.codigoChamadoEncaminhar,
          codigoEnvolvido: this.codigoEnvolvidoEncaminhar,
          descricaoHistorico: 'Aluno encaminhado a Rede Hospitalar.',
          statusChamado: 3,
          codigoPerfil: this.userLogado?.flPsicologo ? this.userLogado.codigoPerfil : this.atribuicoesLogin.CodigoPerfil,
          nomePerfil: this.userLogado?.flPsicologo ? this.userLogado.nomePerfil : this.atribuicoesLogin.NomePerfil,
          nomeArquivo: "",
          caminhoArquivo: "",
          conteudo: ""
        };
        response = await lastValueFrom(this.encaminhamentoService.setCadastrarEncaminhamentoSaude(objetoHistorico))
          .catch((err) => {
            return this.ConvivaErrors.handleResultError(err);
          });
        break;

      default:
        this.spinnerService.hide();
        return;
    }

    if (!response.isSucess) {
      this.toastr.error(response.message, response.title);
      this.spinnerService.hide();
      return;
    }

    this.spinnerService.hide();
    
    const mensagens: { [key: string]: string } = {
      'psicologo': 'Encaminhamento ao Psicólogo realizado com sucesso.',
      'rede-protetiva': 'Encaminhamento à Rede Protetiva realizado com sucesso.',
      'rede-hospitalar': 'Encaminhamento à Rede Hospitalar realizado com sucesso.'
    };
    
    this.mensagemSucessoEncaminhamento = mensagens[this.tipoEncaminhamento];
    
    // Fecha modal de confirmação e abre modal de sucesso
    this.showModalConfirmarEncaminhamento = false;
    this.showModalSucessoEncaminhamento = true;
  }

  public realizarAgendamento(envolvido: Envolvido) {
    // Abre modal para selecionar tipo de agendamento
    this.envolvidoAgendamento = envolvido;
    this.showModalAgendamento = true;
  }

  public fecharModalAgendamento() {
    this.showModalAgendamento = false;
    this.envolvidoAgendamento = null;
  }

  public navegarParaPrevencao() {
    this.showModalAgendamento = false;
    // Redireciona para agendamento de prevenção
    this.router.navigate(['/agendamento-visita-prevencao'], {
      queryParams: {
        ra: this.envolvidoAgendamento?.ra,
        nome: this.envolvidoAgendamento?.nome
      }
    });
  }

  public navegarParaAcolhimento() {
    this.showModalAgendamento = false;
    // Redireciona para agendamento de acolhimento  
    this.router.navigate(['/agendamento-psicologos'], {
      queryParams: {
        ra: this.envolvidoAgendamento?.ra,
        nome: this.envolvidoAgendamento?.nome
      }
    });
  }

  private async buscarHistoricoPorEnvolvido(codigoEnvolvido: number): Promise<HistoricoChamado[]> {
    const chamadoEnvolvido = new ListarChamados();
    chamadoEnvolvido.codigoChamado = this.parametroId;
    chamadoEnvolvido.codigoEnvolvido = codigoEnvolvido;

    const result = await lastValueFrom(await this.chamadoService.getHistoricoEnvolvido(chamadoEnvolvido))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });

    if (result?.isSucess && Array.isArray(result.data)) {
      return result.data;
    }

    return [];
  }

  private async obterHistoricoChamadoComFallback(): Promise<HistoricoChamado[]> {
    const historicoGeral = await this.buscarHistoricoPorEnvolvido(0);

    const codigosEnvolvidos = Array.from(
      new Set(
        (this.envolvidos ?? [])
          .map((envolvido) => envolvido.cdEnvolvido)
          .filter((codigo): codigo is number => !!codigo && codigo > 0)
      )
    );

    const historicoConsolidado: HistoricoChamado[] = [...historicoGeral];
    for (const codigoEnvolvido of codigosEnvolvidos) {
      const historicoEnvolvido = await this.buscarHistoricoPorEnvolvido(codigoEnvolvido);
      historicoConsolidado.push(...historicoEnvolvido);
    }

    if (historicoConsolidado.length === 0) {
      return [];
    }

    const historicoUnico = new Map<string, HistoricoChamado>();
    historicoConsolidado.forEach((historico) => {
      const chave = historico.codigoHistorico
        ? `id-${historico.codigoHistorico}`
        : `${historico.codigoEnvolvido}-${historico.statusChamado}-${historico.data}-${historico.hora}-${historico.descricaoHistorico}`;

      if (!historicoUnico.has(chave)) {
        historicoUnico.set(chave, historico);
      }
    });

    return Array.from(historicoUnico.values())
      .sort((a, b) => this.obterDataHoraHistoricoEmTimestamp(a) - this.obterDataHoraHistoricoEmTimestamp(b));
  }

  private obterDataHoraHistoricoEmTimestamp(historico: HistoricoChamado): number {
    if (historico.dataHistorico) {
      const timestamp = new Date(historico.dataHistorico).getTime();
      return Number.isNaN(timestamp) ? 0 : timestamp;
    }

    if (!historico.data) {
      return 0;
    }

    const partesData = historico.data.split('/');
    if (partesData.length !== 3) {
      return 0;
    }

    const [dia, mes, ano] = partesData.map(Number);
    const [hora, minuto] = (historico.hora ?? '00:00').split(':').map(Number);

    const timestamp = new Date(ano, mes - 1, dia, hora || 0, minuto || 0).getTime();
    return Number.isNaN(timestamp) ? 0 : timestamp;
  }

  private obterChaveUnicaHistoricoStatus(historico: HistoricoChamado): string {
    const timestamp = this.obterDataHoraHistoricoEmTimestamp(historico);
    const data = historico.data ?? '';
    const hora = historico.hora ?? '';
    const descricao = (historico.descricaoHistorico ?? '').trim().toLowerCase();
    return `${historico.statusChamado}-${timestamp}-${data}-${hora}-${descricao}`;
  }

  private isHistoricoStatusRelevante(historico: HistoricoChamado): boolean {
    if (historico.statusChamado !== null && historico.statusChamado !== undefined && historico.statusChamado !== 0) {
      return true;
    }

    const descricao = (historico.descricaoHistorico ?? '').trim().toLowerCase();
    return descricao === 'chamado aberto' || descricao === 'chamado alterado';
  }

  // Histórico de Status
  public async carregarHistoricoStatus() {
    const historicoCompleto = await this.obterHistoricoChamadoComFallback();
    const historicoOrdenado = historicoCompleto
      .filter((hist) => hist.statusChamado !== null && hist.statusChamado !== undefined)
      .filter((hist) => this.isHistoricoStatusRelevante(hist))
      .sort((a, b) => this.obterDataHoraHistoricoEmTimestamp(a) - this.obterDataHoraHistoricoEmTimestamp(b));

    const historicoStatusUnico = new Map<string, HistoricoChamado>();
    historicoOrdenado.forEach((historico) => {
      const chave = this.obterChaveUnicaHistoricoStatus(historico);
      if (!historicoStatusUnico.has(chave)) {
        historicoStatusUnico.set(chave, historico);
      }
    });

    this.historicosStatus = Array.from(historicoStatusUnico.values());
  }

  public async abrirModalHistoricoStatus() {
    this.spinnerService.show();
    try {
      await this.carregarHistoricoStatus();
      this.showModalHistoricoStatus = true;
    } finally {
      this.spinnerService.hide();
    }
  }

  public fecharModalHistoricoStatus() {
    this.showModalHistoricoStatus = false;
  }

  // Carregar histórico de anotações para o sidebar
  public async carregarHistoricoAnotacoes() {
    this.lstHistoricos = await this.obterHistoricoChamadoComFallback();
  }

  public getStatusNome(statusCode: number): string {
    const statusNomes: { [key: number]: string } = {
      0: 'Criado',
      1: 'Encaminhado ao Psicólogo',
      2: 'Encaminhado à Rede Protetiva',
      3: 'Encaminhado à Rede Hospitalar',
      4: 'Agendado',
      5: 'Atendido',
      6: 'Concluído'
    };
    return statusNomes[statusCode] || `Status ${statusCode}`;
  }

  public podeConcluirChamado(chamado: ChamadoDetalhes) {
    const alunos = this.chamado.envolvidos.filter(x => x.tipoPessoa == 3);
    return this.userLogado?.funcionalidades?.includes(2) &&
      this.chamado.status != 4 ||
      (this.chamado.status == 3 && alunos.length > 0);
  }

  public fecharMenuOpcoes() {
    const checkbox = document.getElementById('opcoes-chamado-01') as HTMLInputElement;
    if (checkbox) {
      checkbox.checked = false;
    }
  }

  public AbrirModalConcluirChamado(codigoChamdo: number) {
    this.showModalConcluirChamado = true;
    this.descricaoConcluir = `Deseja concluir o chamado ?`;
    this.chamadoAConcluir = codigoChamdo;
  }

  public FecharModalConcluir() {
    this.showModalConcluirChamado = false;
  }

  public AbrirModalEncerrarChamado(codigoChamdo: number) {
    this.ShowModalEncerrarChamado = true;
    this.descricaoConcluir = `Deseja encerrar o chamado do envolvido?`;
    this.chamadoAConcluir = codigoChamdo;
  }

  public FecharModalEncerrarChamado() {
    this.ShowModalEncerrarChamado = false;
  }

  public async ConcluirChamado() {

    const objetoHistorico: HistoricoChamado = {
      codigoChamado: this.chamado.cdChamado,
      codigoEnvolvido: 0,
      descricaoHistorico: 'Chamado deste envolvido concluído.',
      statusChamado: 6,
      nomeArquivo: "",
      caminhoArquivo: "",
      conteudo: "",

    };

    this.FecharModalConcluir();
    this.spinnerService.show();

    const result = await lastValueFrom(await this.concluirService.setCadastrarConcluirChamadoEnvolvidos(objetoHistorico))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });

    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }

    this.spinnerService.hide();
    this.toastr.success('Chamado deste envolvido concluído com sucesso.');
  }

  public OnExcluirChamado(codigoChamdo: number) {
    this.showModalExcluirChamado = true;
    this.descricaoExclusao = `Deseja remover o chamado ?`;
    this.chamadoARemover = codigoChamdo;
  }

  public FecharModalExclusao() {
    this.showModalExcluirChamado = false;
    this.descricaoExclusao = "";
    this.chamadoARemover = 0;
  }

  public async ExcluirChamado(codigoChamado: number) {
    this.spinnerService.show();
    const chamadoDeletar: ChamadoDeletar = {
      cdChamado: codigoChamado,
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil
    }
    const response = await lastValueFrom(this.chamadoService.setDeletarChamado(chamadoDeletar))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.spinnerService.hide();
    this.toastr.success('Chamado removido com sucesso!');
    this.FecharModalExclusao();
  }

  //  ***** Botoes de Encaminhamento *****
  public PrepararEncaminhamento(tipo: string){

    this.cssBtnPsicologo = "";
    this.cssBtnPolicia = "";
    this.cssBtnHospital = "";
        
    switch (tipo) {
      case "psicologo": //psicologo
        this.cssBtnPsicologo = "btn-encaminhamento-checado";
        this.tipoEncaminhamento = "psicologo";
        break;  
      case "rede-protetiva"://policia
        this.cssBtnPolicia = "btn-encaminhamento-checado";
        this.tipoEncaminhamento = "rede-protetiva";
        break;
      case "rede-hospitalar"://hospitalar
        this.cssBtnHospital = "btn-encaminhamento-checado";
        this.tipoEncaminhamento = "rede-hospitalar";
        break;
    }  
  
  }



  // ***** Tipo de encaminhamento para rede protetiva *****
  public onChangeTEP(tipo: number){

    const divAlerta = document.getElementById("dvAlerta");
    const elements: NodeListOf<HTMLElement> = document.getElementsByName('encaminhamento');

     if (elements && divAlerta) {

        elements.forEach(el => el.classList.remove('msg-alerta'));
        divAlerta.style.display = 'none';
        this.tipoEncaminhamentoPolicia = tipo;
     }

  }


  // ***** Envolvidos *****
  public SelecionarVitima(){
    
     if (this.codigoEnvolvidoEncaminhar > 0) {
        this.showModalEncaminhar = true;
        this.showModalSelecionarEnvolvidoEncaminhamento = false;
      }
  }

  public onChangeEnvolvido(event: any){
      this.codigoEnvolvidoEncaminhar = event.target.value;
  }

}
